<template>
  <div data-test="class-room-add">
    <van-form class="full-page" ref="form">
      <van-field
        class="error-color"
        readonly
        name="picker"
        label="校区"
        :disabled="type=='edit'"
        :clickable="type!='edit'"
        required
        :right-icon="'arrow'"
        placeholder="请选择校区"
        v-model="room.campusName"
        @click.stop="x3chooseCampus()"
        error-message="教室新增后校区不能再进行修改"
        :rules="[{ required: true, message: '必填', trigger: 'onChange' }]">
      </van-field>
      <van-field
        required
        clearable
        label="教室名称"
        placeholder="请输入教室名称"
        :formatter="(v) => v.trimLeft()"
        v-model="room.roomName"
        maxlength="100"
        :rules="[{ required: true, message: '必填' }]"
        :readonly="(type == 'edit')&&!app.permission.op('edit_class_room')"
      />
      <van-field
        required
        clearable
        type="digit"
        maxlength="4"
        label="可容纳人数"
        placeholder="请输入可容纳人数"
        v-model="room.capacity"
        :formatter="(v) => v.trimLeft()"
        :rules="[{ required: true, message: '必填' }]"
        :readonly="(type == 'edit')&&!app.permission.op('edit_class_room')"
      />
      <van-field
        label="状态"
        label-width="auto"
        input-align="right"
      >
        <template #label>
          <div>状态</div>
          <div class="desc-container">停用后，新增班级或排课时不能选择该教室</div>
        </template>
        <template #input>
          <van-switch :value="room.status" size="24" :active-value="1" :inactive-value="0" @click="updateStatus"/>
        </template>
      </van-field>
      <van-field
        v-model="room.remark"
        rows="5"
        type="textarea"
        maxlength="500"
        placeholder="请输入教室备注，备注信息仅对校区内部展示"
        show-word-limit
        :readonly="(type == 'edit')&&!app.permission.op('edit_class_room')"
      />
    </van-form>

    <pageFooterBtn :absolute="true" @click="submit" v-if="((type == 'edit')&&app.permission.op('edit_class_room'))||(type == 'add')"/>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: "baseRoomAdd",
  components: { pageFooterBtn },
  data() {
    let type = this.$route.query.type,
      pageTitle,
      msg;
    if (type == "add") {
      msg = "新增教室成功";
      pageTitle = "添加教室";
    } else if (type == "edit") {
      //   api = this.$api.putCampus
      msg = "修改教室成功";
      pageTitle = "修改教室";
    }
    return {
      pageTitle: "新增教室",
      //type: "add" => 新增， "edit" => 编辑
      type: type,
      msg: msg,
      room: {
        campusId: app.teacher.campusId, // 校区id
        campusName: app.teacher.campus.name,
        roomName: "",
        capacity: "",
        remark: "",
        status: 1,
      }
    };
  },
  methods: {
    updateStatus(){
      this.room.status = Number(!this.room.status);
    },
    submit() {
      this.$refs.form
        .validate()
        .then(() => {
          let requestApi = this.$route.query.type === 'add' 
            ? this.$api.postClassRoom
            : this.$api.putClassRoom
          return requestApi(this.room);
        })
        .then((res) => {
          if (res.code == 200) {
            this.$toast.success(this.msg);
            app.vue.$emit("room-list-update");
            this.$router.back();
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          console.error(err);
          if (Array.isArray(err)) {
            this.$refs.form.scrollToField(err[0].name);
          }
        });
    },
    // 选择校区
    async x3chooseCampus() {
      if (this.type=='edit') return;
      let res = await app.x3.side.xsCampus({
        id: this.room.campusId,
        config: {
          must: true,
          enableAdd: true
        },
      });

      this.room.campusId = res.id;
      this.room.campusName = res.name;
    }
  },
  created() {
    if (this.type == "edit") {
      this.pageTitle = "编辑教室";
      this.showLoading();
      this.$api
        .getClassRoom({
          classRoomId: this.$route.query.id,
        })
        .then((res) => {
          vant.Toast.clear();
          if (res.code === 200) {
            this.room = res.data;
          } else {
            this.$toast.fail(res.msg);
          }
        });
    } else {
      this.pageTitle = "新增教室";
    }
  }
};
</script>

<style lang="scss" scoped>
.error-color {
  ::v-deep .van-field__error-message {
    color: var(--g5);
  }
}
.desc-container {
  color: var(--g6);
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);  
}
</style>
